import { Box } from '@mui/material';
import * as R from 'ramda';

import {
  selectActiveChapterId,
  selectIsNavBannerVisible,
  useAppSelector,
} from '@/store';
import { appStyles } from '@/theme';

export const PageSidebar = ({ children }: { children: React.ReactNode }) => {
  const isNavBannerVisible = useAppSelector(selectIsNavBannerVisible);
  const activeChapterId = useAppSelector(selectActiveChapterId);

  return (
    <Box
      sx={[
        ({ dimensions }) => ({
          width: dimensions.pageSidebar.width,
          borderRight: 1,
          borderRightColor: 'grey100',
          height: '100vh',
          backgroundColor: 'sand150',
          position: 'fixed',
          left: 0,
          top: 0,
          display: { xs: 'none', md: 'block' },
          pt: `${dimensions.header.height + (isNavBannerVisible ? dimensions.navBanner.height : 0)}px`,
          pb: R.map(
            value => (activeChapterId ? `${value}px` : 0),
            dimensions.miniPlayer.height,
          ),
          overflow: 'scroll',
        }),
        appStyles.scrollbar,
      ]}>
      {children}
    </Box>
  );
};
